// Display-only approved laser all-units tiers. NEVER creates a cart-eligible variant.
(function(root){
 'use strict';
 var tiers=Object.freeze([{min:1,max:4,unitCents:600},{min:5,max:24,unitCents:400},{min:25,max:99,unitCents:300},{min:100,max:199,unitCents:250}].map(Object.freeze));
 var quickQuantities=Object.freeze([1,5,10,20,25,40,50,75,100,199]);
 function quote(quantity,backing){
  if(!Number.isSafeInteger(quantity)||quantity<1||quantity>199||(backing!=='lonestar'&&backing!=='pressure'))return null;
  var tier=tiers.find(function(t){return quantity>=t.min&&(t.max===null||quantity<=t.max)}),baseCents=quantity*tier.unitCents,backingCents=backing==='pressure'?quantity*15:0,totalCents=baseCents+backingCents;
  if(!Number.isSafeInteger(totalCents))return null;
  return Object.freeze({quantity:quantity,unitCents:tier.unitCents,baseCents:baseCents,backingCents:backingCents,totalCents:totalCents,tierLabel:tier.min+(tier.max===null?'+':'–'+tier.max)+' patches per color',checkoutEligible:false});
 }
 var api=Object.freeze({mode:'calculator-only',quote:quote,tiers:tiers,quickQuantities:quickQuantities});
 if(typeof module==='object'&&module.exports)module.exports=api;else root.RTBLaserPricing=api;
})(typeof window==='object'?window:globalThis);
